import React from 'react';
import { X, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-gray-50" data-id="element-157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-160">
            El problema real no es la falta de ideas
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-161">
            Es que intentas empezar como si tuvieras tiempo infinito, energía
            infinita y cero miedo. Pero tu vida real es trabajo + familia +
            cansancio.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-162">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-163">
            <div className="flex items-center gap-3 mb-6" data-id="element-164">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-165">
                <X className="w-6 h-6 text-red-600" data-id="element-166" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-167">
                Esto NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-168">
              <li className="flex items-start gap-3 text-gray-600" data-id="element-169">
                <span className="mt-1.5 w-1.5 h-1.5 bg-red-400 rounded-full flex-shrink-0" data-id="element-170"></span>
                Buscas hacerte rica rápido sin esfuerzo.
              </li>
              <li className="flex items-start gap-3 text-gray-600" data-id="element-171">
                <span className="mt-1.5 w-1.5 h-1.5 bg-red-400 rounded-full flex-shrink-0" data-id="element-172"></span>
                No quieres vender nada ni hablar con nadie.
              </li>
              <li className="flex items-start gap-3 text-gray-600" data-id="element-173">
                <span className="mt-1.5 w-1.5 h-1.5 bg-red-400 rounded-full flex-shrink-0" data-id="element-174"></span>
                Quieres un "negocio perfecto" antes de hacer tu primera prueba.
              </li>
            </ul>
          </div>

          <div className="bg-teal-50 p-8 rounded-2xl shadow-sm border border-teal-100" data-id="element-175">
            <div className="flex items-center gap-3 mb-6" data-id="element-176">
              <div className="bg-teal-100 p-2 rounded-full" data-id="element-177">
                <AlertCircle className="w-6 h-6 text-teal-600" data-id="element-178" />
              </div>
              <h3 className="text-xl font-bold text-teal-900" data-id="element-179">
                Esto SÍ es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-180">
              <li className="flex items-start gap-3 text-teal-800" data-id="element-181">
                <span className="mt-1.5 w-1.5 h-1.5 bg-teal-500 rounded-full flex-shrink-0" data-id="element-182"></span>
                Estás en USA, hablas español y sientes que el dinero no alcanza.
              </li>
              <li className="flex items-start gap-3 text-teal-800" data-id="element-183">
                <span className="mt-1.5 w-1.5 h-1.5 bg-teal-500 rounded-full flex-shrink-0" data-id="element-184"></span>
                Quieres un ingreso extra, pero no puedes dedicar 20 horas a la
                semana.
              </li>
              <li className="flex items-start gap-3 text-teal-800" data-id="element-185">
                <span className="mt-1.5 w-1.5 h-1.5 bg-teal-500 rounded-full flex-shrink-0" data-id="element-186"></span>
                Has guardado 50 videos de "ideas de negocio" y sigues sin
                empezar.
              </li>
              <li className="flex items-start gap-3 text-teal-800" data-id="element-187">
                <span className="mt-1.5 w-1.5 h-1.5 bg-teal-500 rounded-full flex-shrink-0" data-id="element-188"></span>
                No quieres "hacerte influencer". Solo quieres{' '}
                <strong data-id="element-189">clientes</strong>.
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl border-l-4 border-orange-500 shadow-md" data-id="element-190">
          <p className="text-lg text-gray-700 italic" data-id="element-191">
            "Tu cerebro hace lo que sabe hacer: procrastinar con contenido. La
            solución no es otro curso largo. La solución es un sistema que te
            obligue a elegir, probar y decidir."
          </p>
        </div>
      </div>
    </section>;
}